/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import MainLayout from 'components/layouts/main'
import {
  deleteDuplicateFPHistory,
  getDegodsFields,
  getDuplicateMagicEdenSlugs,
  getMissingHyperspaceSlugsList,
  getTestList,
  setCollectionInactive,
  setCollectionInactiveDuplicateMeSlugs,
} from 'services'
import Button from 'components/commons/button'
import { notifySuccess } from 'components/commons/toast'
import { ToastContainer } from 'react-toastify'

const TrendingCollectionsPage = () => {
  const [fpHistory, setFpHistory] = useState([])
  const [duplicateMeSlugs, setDuplicateMeSlugs] = useState<any>([])
  const [missingHyperspaceSlugs, setMissingHyperspaceSlugs] = useState<any>([])
  const [testList, setTestList] = useState<any>([])

  useEffect(() => {
    getFields()
  }, [])

  const getFields = async () => {
    getDuplicateMagicEdenSlugs().then((list: any) => {
      setDuplicateMeSlugs(list)
    })
    getMissingHyperspaceSlugsList().then((temp: any) => {
      setMissingHyperspaceSlugs(temp)
    })
    getTestList().then((list: any) => {
      setTestList(list)
    })
    return

    console.log('temp: ')
    const duplicateList: any = []
    getDegodsFields().then((temp1: any) => {
      console.log('temp1: ', temp1)
      for (let i = 0; i < temp1.length; i++) {
        for (let j = 0; j < temp1.length; j++) {
          // 86 vs 172, 75 vs 150
          /* if (temp1[i].price_date == temp1[j].price_date && temp1[i].id != temp1[j].id) {
            duplicateList.push(temp1[j])
          }*/
          /* if ('0' + temp1[i].price_date == temp1[j].price_date && temp1[i].id != temp1[j].id) {
            duplicateList.push(temp1[j])
          }*/
          const splitTemp = temp1[i].price_date.split('/')
          if (
            '0' + splitTemp[0] + '/0' + splitTemp[1] + '/' + splitTemp[2] == temp1[j].price_date &&
            temp1[i].id != temp1[j].id
          ) {
            // duplicateList.push(temp1[i])
            duplicateList.push(temp1[j])
          }
        }
      }
      console.log('duplicateList: ', duplicateList)
      setFpHistory(temp1)
      // deleteDuplicateFPHistory(duplicateList)
    })

    // console.log('temp1: ', temp1)
  }

  const setInactiveDuplicateCollection = async (id: any) => {
    setCollectionInactiveDuplicateMeSlugs(id)
    notifySuccess('Success!')
  }

  return (
    <React.Fragment>
      <MainLayout style={{ backgroundColor: '#FFFFFF' }}>
        <div style={{ backgroundColor: '#FFFFFF' }}>
          <h1 className='font-bold text-4xl text-center py-10 md:text-left lg:text-left md:px-6 lg:px-6'>
            Test List
          </h1>

          <div>
            {testList.map((fpPoint: any) => (
              <p key={fpPoint.id}>
                {fpPoint.price_date}, {'   '} {fpPoint.floor_price}, {'   '} {fpPoint.id},{' '}
              </p>
            ))}
          </div>
        </div>

        <div style={{ backgroundColor: '#FFFFFF' }}>
          <h1 className='font-bold text-xl text-center py-10 md:text-left lg:text-left md:px-6 lg:px-6'>
            Duplicate ME Slugs
          </h1>

          <div style={{ paddingLeft: 24 }}>
            {duplicateMeSlugs.map((doc: any) => (
              <div
                key={doc.id}
                className='flex flex-row'
                style={{ alignItems: 'center', marginBottom: 24 }}
              >
                <img src={doc.image_url} width={60} height={60} style={{ marginRight: 24 }} />

                <div className='flex flex-col'>
                  <p>
                    {''} {doc.slug} {'   ( ME:'} {doc.magic_eden_slug}
                    {' )  -  '} {doc.id}
                  </p>
                  <p>
                    {'Active: '} {doc.active ? 'True' : 'False'}
                  </p>
                </div>
                <Button
                  style={{
                    color: '#03a9f4',
                    fontWeight: '500',
                    marginLeft: 24,
                    textDecoration: 'underline',
                  }}
                  onClick={() => {
                    {
                      window.open(
                        'https://opensea.io/collection/' + doc.slug,
                        '_blank',
                        'noopener,noreferrer',
                      )
                    }
                  }}
                >
                  https://opensea.io/collection/{doc.slug}
                </Button>
                <Button
                  onClick={() => {
                    setInactiveDuplicateCollection(doc.id)
                  }}
                  className='bg-gray-500 font-semibold text-white capitalize px-6'
                >
                  Set Active: False
                </Button>
              </div>
            ))}
          </div>
        </div>

        <div style={{ backgroundColor: '#FFFFFF' }}>
          <h1 className='font-bold text-xl text-center py-10 md:text-left lg:text-left md:px-6 lg:px-6'>
            Missing Hyperspace Slugs
          </h1>

          <div style={{ paddingLeft: 24 }}>
            {missingHyperspaceSlugs.map((doc: any) => (
              <div
                key={doc.id}
                className='flex flex-row'
                style={{ alignItems: 'center', marginBottom: 24 }}
              >
                <img src={doc.image_url} width={60} height={60} style={{ marginRight: 24 }} />

                <div className='flex flex-col'>
                  <p>
                    {''} {doc.slug} {'   ( ME:'} {doc.magic_eden_slug}
                    {' )  -  '} {doc.id}
                  </p>
                </div>
                <Button
                  style={{
                    color: '#03a9f4',
                    fontWeight: '500',
                    marginLeft: 24,
                    textDecoration: 'underline',
                  }}
                  onClick={() => {
                    {
                      window.open(
                        'https://opensea.io/collection/' + doc.slug,
                        '_blank',
                        'noopener,noreferrer',
                      )
                    }
                  }}
                >
                  https://opensea.io/collection/{doc.slug}
                </Button>
              </div>
            ))}
          </div>
        </div>

        {/* <div style={{ backgroundColor: '#FFFFFF' }}>
          <h1 className='font-bold text-4xl text-center py-10 md:text-left lg:text-left md:px-6 lg:px-6'>
            Trending Collections Dashboard
          </h1>

          <div>
            {fpHistory.map((fpPoint: any) => (
              <p key={fpPoint.id}>
                {fpPoint.price_date}, {'   '} {fpPoint.floor_price}, {'   '} {fpPoint.id},{' '}
              </p>
            ))}
          </div>
            </div>*/}
        <ToastContainer limit={1} autoClose={3000} />
      </MainLayout>
    </React.Fragment>
  )
}

export default TrendingCollectionsPage
